import { find, trim } from 'lodash'
const getQueryArray = (value = []) => {
  if (value && typeof value === 'string') return Array(value)
  return value
}

export const getCookie = (name: string) => {
  const cookieArr = document?.cookie?.split(';')
  const cookie = find(cookieArr, (cookie) => {
    return trim(cookie.split('=')[0]) === name
  })

  if (cookie) {
    return decodeURIComponent(cookie.split('=')[1])
  } else {
    return null
  }
}

export const getDomain = () => {
  if (typeof window !== 'undefined') {
    const domain = window.location.hostname
    if (domain === 'localhost') return 'localhost'
    const cookieDomain = domain.substring(domain.lastIndexOf(".", domain.lastIndexOf(".") - 1) + 1);
    return `.${cookieDomain}`
  }
  return ''
}

export default getQueryArray
